<template>
	<div>
		<div v-if="data.adminPanel && !data.hideBack" class="pb-3 text-left">
			<v-btn class="" dark small left title="بازگشت" @click="$emit('back')">
				بازگشت
				<v-icon dark>
					mdi-chevron-left
				</v-icon>
			</v-btn>
		</div>

		<div>
			<div class="text-h4 mb-3 text-center">
				دفترچه اقساط
			</div>
		</div>

		<div>
			<v-data-table :loading="loading" :headers="headers" :items="installments" :items-per-page="50" class="elevation-1">
				<template v-slot:item.installmentAmount="{ item }">
					{{ item.installmentAmount.toString().toPriceFormat() }}
				</template>
				<template v-slot:item.sumAmount="{ item }">
					<div class="" :class="item.loanPaymentOthers ? 'dff' : ''">{{ item.sumAmount.toString().toPriceFormat() }}</div>
					<div class="grey--text">
						<small v-html="paymentInfo(item)"></small>
						<v-tooltip color="#eaeaea" top v-if="item.paymentMethod === 4 && item.memberPurchases && item.memberPurchases.length">
							<template v-slot:activator="{ on, attrs }">
								<v-btn fab dark x-small color="secondary" outlined class="mr-2" style="transform:scale(0.7)">
									<v-icon dark v-bind="attrs" v-on="on">
										mdi-exclamation
									</v-icon>
								</v-btn>
							</template>
							<v-card elevation="0" color="#eaeaea" class="pa-3" v-for="mp in item.memberPurchases.filter(x => x.isPaymentSuccess)" :key="mp.id" style="width: 300px">
								<div><small class="grey--text">درگاه:</small> {{ mp.onlinePaymentGatewayText }}</div>
								<div><small class="grey--text">مبلغ:</small> {{ mp.amount.toString().toPriceFormat() }}</div>
								<div><small class="grey--text">تاریخ و ساعت:</small> &lrm;{{ mp.startDate_Persian.date }} {{ mp.startDate_Persian.time }}</div>
								<gateway-details :data="mp" />
								<v-divider></v-divider>
							</v-card>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.saveDate_Persian="{ item }">
					<div>
						{{ item.saveDate_Persian.date }}
					</div>
					<div v-for="other in (item.loanPaymentOthers || [])" :key="other.id" class="">
						{{ other.saveDate_Persian.date }}
					</div>
				</template>
				<template v-slot:item.delayDay="{ item }">
					<div :class="item.delayDay > 0 ? 'red--text' : 'success--text'" v-if="item.delayDay != 0">
						<div>{{ item.delayDay > 0 ? 'دیرکرد' : 'زودکرد' }}: {{ Math.abs(item.delayDay) }} روز</div>
						<div>{{ item.delayPrice.toString().toPriceFormat() }} تومان</div>
					</div>
					<div v-else-if="item.sumAmount !== 0" class="grey--text">
						بدون تاخیر
					</div>
				</template>
				<template v-slot:item.appSmsList="{ item }" class="text-center">
					<app-sms-detail :data="item.appSmsList" :entityId="item.id" />
				</template>
				<template v-slot:item.operations="{ item }">
					<div v-if="data.adminPanel" class="text-center">
						<v-btn class="mx-1" fab dark small color="green" @click="showPayment(item)">
							<v-icon dark>
								mdi-currency-usd
							</v-icon>
						</v-btn>
						<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
							<v-icon dark>
								mdi-square-edit-outline
							</v-icon>
						</v-btn>
						<v-btn :disabled="!checkPermission('Delete_Installmet')" class="mx-1" fab dark small color="pink" @click="remove(item)">
							<v-icon dark>
								mdi-trash-can-outline
							</v-icon>
						</v-btn>
					</div>
					<div v-else class="text-center">
						<v-btn class="mx-2" text small color="secondary" title="" v-if="item.userLoanPaymentRequestId">
							برای این قسط اعلام واریزی ثبت کرده اید
						</v-btn>
						<v-btn v-else-if="item.sumAmount < item.installmentAmount" class="mx-2" small color="secondary" @click="paymentRequest(item)" title="اعلام واریزی">
							<v-icon dark class="ml-1">
								mdi-thumb-up-outline
							</v-icon>
							اعلام واریزی
						</v-btn>
						<v-btn :disabled="!isOnlinePaymentActive || item.sumAmount >= item.installmentAmount" class="mx-2" small color="warning" @click="payOnline(item)" title="پرداخت آنلاین">
							<v-icon dark class="ml-1">
								mdi-credit-card-outline
							</v-icon>
							پراخت آنلاین
						</v-btn>
					</div>
				</template>
			</v-data-table>
		</div>

		<v-dialog v-model="dialogModifyLoanPaymentData" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ویرایش قسط</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyLoanPaymentData = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-loan-payment-data ref="modifyLoanPaymentData" v-if="dialogModifyLoanPaymentData" :data="selectedLoanPayment" @callbck="callbck_loanPaymentData" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogModifyLoanPayment" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت واریزی قسط</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyLoanPayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-loan-payment ref="modifyLoanPayment" v-if="dialogModifyLoanPayment" :data="selectedLoanPayment" @callbck="callbck_loanPayment" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogModifyLoanPaymentRequest" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">اعلام واریزی</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyLoanPaymentRequest = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-loan-payment-request ref="modifyLoanPaymentRequest" :isAdmin="data.adminPanel" v-if="dialogModifyLoanPaymentRequest" :data="loanPaymentRequest" @callbck="callbck_loanPaymentRequest" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOnlinePayment" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">پرداخت آنلاین قسط</span></div>
					<v-spacer />
					<v-btn @click="dialogOnlinePayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<online-payment ref="onlinePayment" v-if="dialogOnlinePayment" :data="selectedLoanPayment" @callbck="callbck_onlinePayment" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'

	export default {
		name: 'LoanInstallmentsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-loan-payment': () => import('./ModifyLoanPayment.vue'),
			'modify-loan-payment-data': () => import('./ModifyLoanPaymentData.vue'),
			'modify-loan-payment-request': () => import('@/components/forms/ModifyLoanPaymentRequest.vue'),
			'online-payment': () => import('@/components/forms/OnlinePayment.vue'),
			'gateway-details': () => import('@/components/GatewayDetails'),
			'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				loading: false,
				errorMessages: '',
				dialogModifyLoanPaymentRequest: false,
				dialogModifyLoanPaymentData: false,
				dialogModifyLoanPayment: false,
				dialogOnlinePayment: false,
				selectedLoanPayment: null,
				loanPaymentRequest: null,
				installments: [],
				headers: []
			}
		},
		computed: {
			...get('memberAppSettings', [
				'isOnlinePaymentActive',
			])
		},
		mounted() {
			this.headers = [{
				text: 'شماره قسط',
				align: 'center',
				sortable: true,
				value: 'installmentNumber',
			}, {
				text: 'مبلغ قسط',
				align: 'center',
				sortable: true,
				value: 'installmentAmount',
			}, {
				text: 'سررسید',
				align: 'center',
				sortable: true,
				value: 'targetMonth_Persian.date',
			}, {
				text: 'مبلغ پرداختی',
				align: 'center',
				sortable: true,
				value: 'sumAmount',
			}, {
				text: 'تاریخ واریز',
				align: 'center',
				sortable: true,
				value: 'saveDate_Persian',
			}, {
				text: 'دیرکرد/زودکرد',
				align: 'center',
				sortable: true,
				value: 'delayDay',
			}]
			if (this.data.adminPanel) {
				this.headers.push({
					text: 'ثبت توسط',
					align: 'center',
					sortable: true,
					value: 'savedBy',
				})

				this.headers.push({
					text: 'پیامک ها',
					align: 'center',
					sortable: false,
					value: 'appSmsList',
				})
			}
			this.headers.push({
				text: 'عملیات ها',
				align: 'center',
				sortable: false,
				value: 'operations',
				width: this.data.adminPanel ? 200 : 300,
			})
			this.loadData()
		},
		methods: {
			paymentRequest(payment) {
				if (this.installments.findIndex(x => x.installmentNumber < payment.installmentNumber && !x.userLoanPaymentRequestId) > -1) {
					toast.error('ابتدا باید سررسید های قبلی اعلام واریزی شود.')
					return
				}
				payment.userLoanModel = this.data.userloan
				this.loanPaymentRequest = { id: emptyId, loanPayment: payment, amount: this.data.userloan.installment }
				this.dialogModifyLoanPaymentRequest = true
			},
			edit(payment) {
				this.selectedLoanPayment = { id: payment.id, userLoanModel: this.data.userloan }
				this.dialogModifyLoanPaymentData = true
			},
			showPayment(payment) {
				if (this.installments.findIndex(x => x.installmentNumber < payment.installmentNumber && x.sumAmount === 0) > -1) {
					toast.error('ابتدا باید سررسید های قبلی پرداخت شود.')
					return
				}
				this.selectedLoanPayment = { id: payment.id, userLoanModel: this.data.userloan }
				this.dialogModifyLoanPayment = true
			},
			async remove(item) {
				if (!item) { return }

				if (this.installments.findIndex(x => x.installmentNumber > item.installmentNumber && x.sumAmount != 0) > -1) {
					toast.error('ابتدا باید اقساط بعدی حذف شوند.')
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/loanpayment/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
								this.$emit('changed', this.data.userloan.id)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			loadData() {
				this.loading = true
				api.get('admin/loanpayment/getLoanPayments/' + this.data.userloan.id, null)
					.then(
						response => {
							this.installments = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			callbck_loanPayment(result) {
				this.dialogModifyLoanPayment = false
				if (result) {
					this.loadData()
					this.$emit('changed', this.data.userloan.id)
				}
			},
			callbck_loanPaymentData(result) {
				this.dialogModifyLoanPaymentData = false
				if (result) {
					this.loadData()
					this.$emit('changed', this.data.userloan.id)
				}
			},
			// paymentInfo(paymentRow) {
			// 	let paymentMethods = [
			// 		{ id: 1, title: 'نقدی' },
			// 		{ id: 2, title: 'واریز' },
			// 		{ id: 3, title: 'طلا' },
			// 		{ id: 4, title: 'آنلاین' },
			// 		{ id: 5, title: 'کارتخوان' },
			// 	]
			// 	let payment = paymentMethods.find(x => x.id == paymentRow.paymentMethod)

			// 	if (!payment)
			// 		return ''

			// 	return `پرداخت: ${payment.id == 3 ? paymentRow.goldWeight + ' گرم ' : ''}${payment.title} ${paymentRow.loanPaymentOthers?.length > 0 ? ' و ' + paymentRow.loanPaymentOthers?.length + ' پرداخت دیگر' : ''}`
			// },
			paymentInfo(paymentRow) {
				let paymentMethods = [
					{ id: 1, title: 'نقدی' },
					{ id: 2, title: 'واریز بانکی' },
					{ id: 3, title: 'طلا' },
					{ id: 4, title: 'آنلاین' },
					{ id: 5, title: 'کارتخوان' },
				]

				let payment = paymentMethods.find(x => x.id == paymentRow.paymentMethod)

				if (!payment)
					return ''

				if (!paymentRow.loanPaymentOthers?.length)
					return `${payment.id == 3 ? paymentRow.goldWeight + ' گرم ' : ''}${payment.title}`

				// خط اصلی پرداخت
				let result = []
				result.push(
					`<span class="black--text">${paymentRow.amount.toString().toPriceFormat()}</span><br/>${payment.id == 3 ? paymentRow.goldWeight + ' گرم ' : ''}${payment.title}`
				)

				// اگر پرداخت‌های دیگر وجود داشت
				if (paymentRow.loanPaymentOthers?.length > 0) {
					paymentRow.loanPaymentOthers.forEach(item => {
						result.push(`<span class="black--text">${item.amount.toString().toPriceFormat()}</span><br/>${paymentMethods.find(x => x.id == item.paymentMethod)?.title}`)
					})
				}

				return result.join('<br/>')
			},

			callbck_loanPaymentRequest(result) {
				this.dialogModifyLoanPaymentRequest = false
				this.loadData()
			},
			callbck_onlinePayment(result) {
				this.dialogOnlinePayment = false
				this.loadData()
			},
			payOnline(payment) {
				if (this.installments.findIndex(x => x.installmentNumber < payment.installmentNumber && x.sumAmount === 0) > -1) {
					toast.error('ابتدا باید سررسید های قبلی پرداخت شود.')
					return
				}
				api.get('member/LoanPayment/get/' + payment.id, null)
					.then(
						response => {
							this.selectedLoanPayment = { payment: response, userLoanModel: this.data.userloan }
							this.dialogOnlinePayment = true
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
	}
</script>
<style>
	.dff {
		border-bottom: 1px dashed #ccc;
		padding-bottom: 5px;
		padding-top: 5px;
	}
</style>
